import { useEffect, useState, useCallback } from "react";
import { getAppointmentsByHistorytId } from "../../api/appointmentService";
import { getAppointmentsByHistoryEntrytId } from "../../api/appointmentService";
import { getUpcomingAppointmentsByPetId } from "../../api/appointmentService";
import { getUpcomingAppointments } from "../../api/appointmentService";
import { getAppointmentsByDate } from "../../api/appointmentService";
export const useHistoryAppointments = (historyId, entryId, petId, date, mode, upcoming = false, trigger, initialPage = 1, initialLimit = 10) => {
    const [appointments, setAppointments] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'pet')
              {
                if (upcoming)
                {
                  response = await getUpcomingAppointmentsByPetId(petId, page, limit);
                }
              } else if (mode === 'dashboard')
              {
                response = await getUpcomingAppointments(page, limit);
              } else if (mode === 'calendar')
              {
                response = await getAppointmentsByDate(date, page, limit);
              }
              else {
                if (entryId)
                {
                  response = await getAppointmentsByHistoryEntrytId(entryId, page, limit);
                } else {
                  response = await getAppointmentsByHistorytId(historyId, page, limit);
                }
              }
              setAppointments(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch appointments:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = appointments.pagination.page + 1;
        if (nextPage <= appointments.pagination.totalPages) {
        await fetchData(nextPage, appointments.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, appointments.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { appointments, loading, loadMore, searchFunction, resetParent };
};